import { dpr } from 'Utils/dpr';

export interface SearchResult {
    baseId: string;
    id: string;
    img: string;
    name: string;
    outOfStock: boolean;
    outOfStockText: string;
    addToCart?: (
        id: string,
        baseId: string,
    ) => any;
}

const ProductSearchResult = ({
    baseId,
    id,
    img,
    name,
    outOfStock,
    outOfStockText,
    addToCart
}: SearchResult) => {
    const selectOnEnterKey = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' && !outOfStock) {
            addToCart(id, baseId);
        }
    };

    return(
        <div
            data-result="product"
            className={
                `flex gap-2 h-full w-full text-black py-2 px-2.5 border-b last:border-b-0 border-[#D5D3DE]
                ${!outOfStock ? 'hover:bg-slate-200 focus-within:bg-slate-200 cursor-pointer' : 'cursor-default'}`
            }
            key={id}
            data-id={id}
            onClick={() => !outOfStock && addToCart(id, baseId)}
            onKeyDown={selectOnEnterKey}
            tabIndex={!outOfStock ? 0 : undefined}
        >
            <figure className={outOfStock ? 'opacity-30': 'opacity-100'}>
                <picture>
                    <source
                        media="(max-width: 1920px)"
                        srcSet={dpr(
                            `${img}?width=78&auto=webp`
                        )}
                    />
                    <img
                        className="h-[52px] w-[39px] object-cover object-bottom"
                        src={`${img}`}
                        srcSet={dpr(`${img}`)}
                        alt={name}
                    />
                </picture>
            </figure>
            <div>
                <div className="text-xs">
                    {id}
                </div>
                <div className="font-semibold leading-4">
                    {name}
                </div>
                {outOfStock && 
                    <div className="text-red-500 leading-4">
                        {outOfStockText}
                    </div>
                }
            </div>
        </div>    
    )
}

export default ProductSearchResult;
